import React, { Component } from 'react';
import investmentsWrapper from '../assets/images/investments-wrapper.jpg';
import blueBackground from '../assets/images/blue-background.jpg';
// import { FormattedMessage } from 'react-intl';
// import config from './../../config';
import { Link } from 'gatsby';
import { localeToLanguageKey, prefixUrlWithLanguage } from '../util/locale';
// import { isThursday } from 'date-fns/esm';

const TRANSLATIONS = {
    en: {
        LEARN_ABOUT_OTHER_INVESTMENTS: 'Learn more about our<br/>other investments',
        COMPANY: 'Company',
        LEARN_MORE: 'Learn more',
        ACQUIRED: 'Acquired',
        EXITED: 'Divested',
    },
    nl: {
        LEARN_MORE: 'Lees meer',
        COMPANY: 'Bedrijf',
        LEARN_ABOUT_OTHER_INVESTMENTS: 'Bekijk onze<br/>andere investeringen',
        ACQUIRED: 'Verworven',
        EXITED: 'Verkocht'
    },
    de: {
        LEARN_ABOUT_OTHER_INVESTMENTS: 'Erfahren Sie mehr über unsere <br/> Portfoliounternehmen',
        COMPANY: 'Unternehmen',
        LEARN_MORE: 'Mehr erfahren',
        ACQUIRED: 'Beteiligung',
        EXITED: 'Vergangene Beteiligungen',
    }
}

function translate(key, language) {
    language = language || 'en';
    return TRANSLATIONS[language][key];
}

export default class OtherInvestments extends Component {

    apiEndpoint = process.env.GATSBY_API_URL;

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            locale: this.props.locale,
            language: localeToLanguageKey(props.locale)
        }
    }

    componentWillReceiveProps(props) {
        // console.log('OOTHER INVESTMENTS', props);
        if (props !== null) {
            this.setState({data: props.data});
        }
    }

    renderSold(options) {
        const { language } = this.state;

        if (!this.state.data) {
            return null;
        }

        const { category } = this.state.data;

        if (category !== "divested") {
            return null;
        }

        return (
            <div>
                <span className="white-label">{translate('EXITED', language)}</span>
                <span className="white-title first-uppercase-letter">{this.state.data ? new Intl.DateTimeFormat(this.props.locale || 'en-GB', options).format(new Date(this.state.data.Sold)) : 'January 2018'}</span>
                <br/>
            </div>
        );
    }

    render() {
        if (!this.state.data) {
            return null;
        }

    let options = {month: 'long', year: 'numeric'};
    const { language } = this.state;
    return (
        <>
            <h4 className="width-80 text-center top-separator bottom-spacing custom-h4 blue-box-title" dangerouslySetInnerHTML={{__html: translate('LEARN_ABOUT_OTHER_INVESTMENTS', language)}}></h4>
            <Link to={prefixUrlWithLanguage(this.state.language, `portfolio/?${this.state.data ? this.state.data.slug : 'arnold-shur'}`)} className="shadowed-link investments-wrapper">
                <div className="half-width relative responsive-first">
                <img className="high-darkened full-width" src={this.state.data ? (this.state.data.portfolio_image ? this.apiEndpoint + this.state.data.portfolio_image.url : investmentsWrapper) : investmentsWrapper} alt="Our other investments"/>
                <img className="logo-img" src={this.state.data ? (this.state.data.company_logo ? this.apiEndpoint + this.state.data.company_logo.url : '') : ''} alt=""/>
                {/*
                <span className="absolute-triangle">
                <img className="high-darkened full-width" src={this.state.data ? (this.state.data.company_logo ? this.apiEndpoint + this.state.data.company_logo.url : '') : ''} alt="Our other investments"/>
                    <span className="triangle-text">
                    </span>
                </span>
                */}
                </div>
                <div className="half-width relative responsive-second">
                <img className="full-width responsive-background-hide" src={blueBackground} alt=""/>
                <div className="absolute-spaced">
                    <span className="white-label">{translate('COMPANY', language)}</span>
                    <span className="white-title">{this.state.data ? this.state.data.company_name : 'Arnold Suhr'}</span>
                    <br/>
                    <span className="white-label">{translate('ACQUIRED', language)}</span>
                    <span className="white-title first-uppercase-letter">{this.state.data ? new Intl.DateTimeFormat(this.props.locale || 'en-GB', options).format(new Date(this.state.data.aquired)) : 'Januari 2018'}</span>
                    <br/>
                    {this.renderSold(options)}
                    <br className="mobile-hidden"/>
                    <br className="mobile-hidden"/>
                    <div className="learn-more">{translate('LEARN_MORE', language)}</div>
                </div>
                </div>
                <div className="clearfix"></div>
            </Link>
        </>
    )

  }

}
